import { Component, OnInit,ViewChild,ElementRef, Inject } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { MetaVisaoAnualDTO } from '@app/pages/relatorios/meta-novos-processos/meta-visao-anual/relatorio-meta-visao-anual';
import { ToastrService } from 'ngx-toastr';
import { ConsultasService } from '@app/services/consultas.service';
import { MetaService } from '@app/services/meta.service';
import { Meta } from '@app/models/meta.model';
import { Unidade } from '@app/models/unidade.model';
import { UnidadeService } from '@app/services/unidade.service';
import { Router } from '@angular/router';


import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-meta-lista',
  templateUrl: './meta-lista.component.html',
  styleUrls: ['./meta-lista.scss']
})
export class MetaListaComponent implements OnInit {
  

  meta: Meta =new Meta(); //forma de inicializar objeto

  pesquisando: boolean;

  anosLista: IdDescricao[] = [];
  anoSelecionado:number;

  unidadeSelecionada:number;

  lstUnidades:IdDescricao[];

  anoMeta: number;
  unidade: number;

  janeiroMeta: number;
  fevereiroMeta: number;
  marcoMeta: number;
  abrilMeta: number;
  maioMeta: number;
  junhoMeta: number;
  julhoMeta: number;
  agostoMeta: number;
  setembroMeta: number;
  outubroMeta: number;
  novembroMeta: number;
  dezembroMeta: number;

  inputAtivo:boolean;
  filtroDescricao: string = "";

  bsModalRef: BsModalRef;

  constructor(
    private _metaService: MetaService,
    private _consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
    private _unidadeService: UnidadeService,
    private _router:Router,
    private modalService:BsModalService
  ) { }

  ngOnInit(): void {
    this._consultasService.consultar('ANOSMETA').subscribe(data => this.anosLista = data)
    this._consultasService.consultar('UNIDADE_S_RATEIO').subscribe(data => this.lstUnidades = data); 
  }

  ativaInputs(){
    if (this.inputAtivo)
      this.inputAtivo = false;
    else 
      this.inputAtivo=true;
  }

  buscarMetas (){
    let ano = this.anosLista.find(x => x.Id === this.anoSelecionado).Descricao;
    this._metaService.obterPorChaveComposta(Number(ano),this.unidadeSelecionada).toPromise().then(
      data=>{
        this.meta=data ?? new Meta();
          if(this.meta.JaneiroMeta ==null) // verificar se tem metas cadastradas
          //// essa verif cabe se arrumar o dropdown unidade conforme o ano
          this.toastr.warning("Não há metas cadastradas para esta unidade neste ano");
      },
      erro => {
        this.toastr.warning("Realize a pesquisa novamente.");
      });
  }

  excluirMeta(){
    let ano = this.anosLista.find(x=> x.Id === this.anoSelecionado).Descricao;
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem='Deseja realmente excluir estas metas?'
    this.bsModalRef.content.confirmar = () => { 

    this._metaService.deletar(Number(ano),this.unidadeSelecionada).subscribe(
      data=>{ 
        this.meta = new Meta();
      },
      erro => {
        this.toastr.warning("Realize a pesquisa novamente.")
      }) 
    },
    (data: any) => {
      this.toastr.error(data.error.errors);
    }
  }
  

  gravarEdicao(){

    this._metaService.gravar(this.meta).toPromise().then(
      data=>{
        this.toastr.success("Meta gravada com sucesso");
      },
      erro => {
        this.toastr.warning(erro.error.errors[0])
      }
    );

  }

  rotaForm(){
    this._router.navigate(['/configuracoes/metas/nova']);
  }
}
